module.exports = "/packs/media/modules/startups/quality-check/components/QualityCheck/images/exampleJuiceFront-bd22fc9e87f99398845d6fe27d519242.png";